export default {"theme":{"dark":false,"themes":{"light":{"primary":"#3DDA84","accent":"#47b4e6","secondary":"#86FDE8","info":"#26a69a","warning":"#ffc107","error":"#dd2c00","success":"#00e676"}}}}
